import { SbsentRequest } from '@/plugins/api'
import { rangeRight } from 'lodash'
export default {
  namespaced: true,
  state: {
    sbsentRequestList: [],
    param: {},
    pageText: '',
    itemsPerPage: 10,
    totalItems: 0,
    loading: false
  },
  actions: {
    async requestPageSettings({ state, commit, dispatch }, { page, itemsPerPage }) {
      state.loading = true
      if (!page) page = 1
      if (!itemsPerPage) itemsPerPage = state.itemsPerPage
      if (state.param) {
        const param = {
          ...state.param,
          _start: (page - 1) * itemsPerPage,
          _limit: itemsPerPage,
          _sort: 'createdAt:DESC'
        }
        const { isAdmin, ...body } = state.param
        const query = {
          ...body,
          _start: (page - 1) * itemsPerPage,
          _limit: itemsPerPage,
          _sort: 'createdAt:DESC'
        }
        const [totalItems, sbsentRequestList] = await Promise.all([
          SbsentRequest.count(query),
          SbsentRequest.fetch(param)
        ])
        if (totalItems > (page - 1) * itemsPerPage || page === 1) {
          commit('changeState', {
            sbsentRequestList,
            totalItems,
            itemsPerPage,
            param
          })

          const pageStart = (page - 1) * itemsPerPage + 1
          let pageStop = page * itemsPerPage
          pageStop = pageStop > totalItems || pageStop === -1 ? totalItems : pageStop
          const pageText = `${pageStart}-${pageStop} trên ${totalItems}`
          commit('setPageText', pageText)
        } else {
          var pages = rangeRight(1, page)
          for (let index = 0; index < pages; index++) {
            const selectedPage = pages[index]
            if (totalItems > (selectedPage - 1) * itemsPerPage) {
              dispatch('requestPageSettings', {})
              break
            }
          }
        }
      }

      state.loading = false
    },
    async fetchSbsentRequests({ commit, dispatch }, query) {
      try {
        const param = query
        commit('changeState', {
          param
        })
        dispatch('requestPageSettings', {})
      } catch (e) {
        alert.error(e)
      }
    },
    async updateSbsentRequest({ commit, state }, query) {
      try {
        const { id, ...body } = query
        const updateResult = await SbsentRequest.update(id, body)
        if (updateResult) {
          const sbsentRequestList = await SbsentRequest.fetch(state.param)
          commit('changeState', {
            sbsentRequestList
          })
        }
        return updateResult
      } catch (e) {
        alert.error(e)
      }
    }
  },
  mutations: {
    setPageText(state, pageText) {
      state.pageText = pageText
    }
  }
}
